/**
 * 基于crypto生成校验码
 * @author  韦胜健
 * @date    2019/10/14 17:55
 */
function cryptoJSEncrypt(word, keyStr) {
    const CryptoJS = window.CryptoJS
    let key = CryptoJS.enc.Utf8.parse(keyStr)
    let srcs = CryptoJS.enc.Utf8.parse(word)
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
}

/**
 * 获取请求校验码
 * @author  韦胜健
 * @date    2019/10/15 15:27
 */
export function getRequestEncrypt({
                                      url,                      //请求地址
                                      method,                   //请求方法：post,get
                                      body,                     //请求体，post或者get请求的参数
                                      cryptoSecret,             //crypto的秘钥
                                      contentType,              //请求体格式
                                      isUploadFile,             //是否为文件上传
                                  }) {
    if (body === undefined || body === null) {body = {}}

    let nowTime = new Date().format('yyyy-MM-dd hh:mm:ss'), secretBody;
    if (!isUploadFile) {
        body = LinkUtils.deepCopy(body)
        switch (method.toLowerCase()) {
            case 'get':
                /*get请求，将参数拼接到url中，body为空，生成校验码*/
                url = LinkUtils.encodeUrl(url, body)
                body = ''
                secretBody = window.md5(JSON.stringify(body))
                return cryptoJSEncrypt(secretBody + '_' + nowTime + '_' + url, cryptoSecret)
            case 'post':
                /*post请求，body为请求参数，生成校验码*/
                if (contentType === 'application/x-www-form-urlencoded') {
                    body = LinkUtils.encodeUrl('', body).substring(1)
                    secretBody = window.md5(body)
                } else if (contentType === '' || contentType == null || contentType.indexOf('application/json') !== -1) {
                    secretBody = window.md5(JSON.stringify(body))
                } else {
                    console.error('无法识别的请求类型Content-type:' + contentType)
                    console.log('无法识别的请求类型Content-type', {url, body, contentType})
                    secretBody = ''
                }

                return cryptoJSEncrypt(secretBody + '_' + nowTime + '_' + url, cryptoSecret)
        }
    } else {
        secretBody = window.md5("multipart/form-data");
        return cryptoJSEncrypt(secretBody + '_' + nowTime + '_' + url, cryptoSecret)
    }
}
